import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const ApplicationSkeleton = () => (
  <div className={s.content}>
    <Paper
      className={s.card}
      padding={[20, 16]}
      radius="20px"
    >
      <Skeleton className={s.title} />
      <Skeleton
        className={s.field}
        borderRadius={16}
      />
    </Paper>

    <Paper
      className={s.card}
      padding={[20, 16]}
      radius="20px"
    >
      <Skeleton className={s.title} />
      <div className={s.fields}>
        <Skeleton
          className={s.field}
          borderRadius={16}
        />
        <Skeleton
          className={s.field}
          borderRadius={16}
        />
      </div>
    </Paper>

    <Paper
      className={s.card}
      padding={[20, 16]}
      radius="20px"
    >
      <Skeleton className={s.title} />
      <Skeleton className={s.counter} />
      <div className={s.fields}>
        <Skeleton
          className={s.field}
          borderRadius={16}
        />
      </div>
      <div className={s.infantSection}>
        <Skeleton className={s.addInfant} />
      </div>
    </Paper>

    <Paper
      className={s.card}
      padding={[20, 16]}
      radius="20px"
    >
      <Skeleton className={s.title} />
      <div className={s.fields}>
        <Skeleton
          className={s.field}
          borderRadius={16}
        />
      </div>
    </Paper>
  </div>
)
